export default {
  EcomCategory: {},
  detailedCategory: {},
  detailedCategoryAll: {},
};
